import React, { memo, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNavbarProduct,
  resetNavbarProducts,
} from "../../redux/features/ProductSlice";
import SingleProduct from "../product/SingleProduct";

const FeaturedProducts = ({ activeSubCategory }) => {
  const dispatch = useDispatch();

  const products = useSelector((state) => state.mainproduct.navbarProduct);

  // Memoize the activeSubCategory to avoid unnecessary re-renders
  const memoizedActiveSubCategory = useMemo(
    () => activeSubCategory,
    [activeSubCategory]
  );

  useEffect(() => {
    if (memoizedActiveSubCategory) {
      dispatch(
        getNavbarProduct({
          params: {
            filters: {
              "category.id": memoizedActiveSubCategory,
            },
            populate: "gallery,variations",
          },
        })
      );
    }
    return () => dispatch(resetNavbarProducts());
  }, [memoizedActiveSubCategory, dispatch]);

  return (
    <div>
      {/* Featured Products */}
      <div className="pl-8">
        <h3 className="text-lg font-bold text-rose-700 mb-4">Featured Products</h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {products?.map((product, i) => (
            <SingleProduct product={product} key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(FeaturedProducts);
